import BaseActionAbstract from 'cio/app-models/action-abstracts/base';
import timeframePropertyComputed from 'cio/utils/timeframe-computed';
import { task } from 'ember-concurrency';
import ActionModel, { ActionType } from '../../models/action';
import { tracked } from '@glimmer/tracking';
import { SerializedLegacyFilter } from 'cio/types/conditions/legacy-filter';
import { dependentKeyCompat } from '@ember/object/compat';

const EDITABLE_PROPERTIES = ['delay', 'preconditions'];
const DIRTY_DEPENDENCIES = `action.{${EDITABLE_PROPERTIES.join(',')}}`;

export default class DelayActionAbstract extends BaseActionAbstract {
  type = 'delay';

  action!: ActionModel;
  actionType!: ActionType;

  _editableProperties: string[] = EDITABLE_PROPERTIES;
  _dirtyDependencies: string = DIRTY_DEPENDENCIES;

  @tracked preconditions: SerializedLegacyFilter[] = [];

  @timeframePropertyComputed({
    countProperty: 'delayCount',
    unitProperty: 'delayUnit',
    defaultUnitWhenZero: 'day',
  })
  delay!: number;

  @tracked delayCount = 0;
  @tracked delayUnit = 'day';

  @dependentKeyCompat
  get errors() {
    let delay = this.delayCount;

    if (isNaN(delay) || typeof delay !== 'number') {
      return {
        delay: ['Delay must be a number'],
      };
    } else if (delay < 0) {
      return {
        delay: ['Time travel is not allowed'],
      };
    }

    return;
  }

  saveTask = task({ drop: true }, async () => {
    let action = this.prepareForSave();

    try {
      let response = await action.save();
      this.prepareForEdit();
      return response;
    } catch (e) {
      action.rollbackAttributes();
      throw e;
    }
  });

  deleteTask = task({ drop: true }, async () => {
    return this.action.campaign.removeActionFromWorkflow(this.action);
  });
}
